/*
 * サブシステム名：受注契約
 * 機能名：受注契約紐づけ画面
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdTextBox from '@/components/DdTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdNumericBox from '@/components/DdNumericBox'
import DdCheckbox from '@/components/DdCheckbox'
import DdIconButton from '@/components/DdIconButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdJuchuKeiyakuKensakuTextBoxSearchOnly from '@/components/DdJuchuKeiyakuKensakuTextBoxSearchOnly'
import DdDialog from '@/views/ORC/JuchuEditDialog.vue'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

// import message from '@/ddv2.library/messages'
import header from '@/ddv2.library/header'

export default {
  name: 'HimodukeEdit',
  mixins: [flowMixin],
  data: () => ({
    id: 0,
    rec: {
      trJuchuKeiyakuId: 0,
      juchuKeiyakuNo: '',
      keiyakuNm: '',
      seikyuTorihikisakiCd: '',
      keiyakuStartYmd: '',
      keiyakuEndYmd: '',
      keiyakuKihonKingaku: 0,
      juchuKeiyakuBiko: '',
      upperList: [], // 上部リストデータ格納用
      lowerList: [] // 下部リストデータ格納用
    },
    rowsUpper: [], // 上部リストSearch用
    rowsLower: [], // 下部リストSearch用
    invalidMessages: {},
    // ヘッダ検索用
    conditions: {
      trJuchuKeiyakuId: 0
    },
    // 上部リスト検索用
    conditions2: {
      trJuchuKeiyakuId: 0,
      seikyuTorihikisakiCd: ''
    },
    // 下部リスト検索用
    conditions3: {
      trJuchuKeiyakuId: 0,
      seikyuTorihikisakiCd: ''
    },
    keiyakuHojoKbn: false,

    // 上部リスト(契約連携済み受注一覧)
    headersUpper: [
      { width: '20px', text: '操作', value: 'actions' },
      { width: '100px', text: '受注番号', value: 'juchuNo' },
      { width: '80px', text: '受注日', value: 'juchuYmd' },
      { width: '120px', text: '受注営業所', value: 'eigyoshoNm' },
      { width: '200px', text: '取引先', value: 'torihikisakiNm' },
      { width: '80px', text: '受注明細番号', value: 'juchuMeisaiNo' },
      { width: '80px', text: '作業予定日', value: 'sagyoYoteiYmd' },
      { width: '150px', text: '荷主', value: 'ninushiNm' },
      { width: '150px', text: '発地', value: 'hatsuchiNm' },
      { width: '150px', text: '卸先', value: 'oroshisakiNm' },
      { width: '150px', text: '着地', value: 'chakuchiNm' },
      { width: '150px', text: '品名', value: 'hinmei' }
    ],
    // 下部リスト(契約未連携受注一覧)
    headersLower: [
      { width: '20px', text: '操作', value: 'actions' },
      { width: '100px', text: '受注番号', value: 'juchuNo' },
      { width: '80px', text: '受注日', value: 'juchuYmd' },
      { width: '120px', text: '受注営業所', value: 'eigyoshoNm' },
      { width: '200px', text: '取引先', value: 'torihikisakiNm' },
      { width: '80px', text: '受注明細番号', value: 'juchuMeisaiNo' },
      { width: '80px', text: '作業予定日', value: 'sagyoYoteiYmd' },
      { width: '150px', text: '荷主', value: 'ninushiNm' },
      { width: '150px', text: '発地', value: 'hatsuchiNm' },
      { width: '150px', text: '卸先', value: 'oroshisakiNm' },
      { width: '150px', text: '着地', value: 'chakuchiNm' },
      { width: '150px', text: '品名', value: 'hinmei' }
    ],
    modeOfEdit: 2, // 0:新規、1:照会、2:更新
    modeKengen: 2, // 0:読取、1:削除不可、2:フル
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    juchuEditDialog: false,
    expansionPanel: [0, 1],
    selected: [], // 下部リストのチェックボックスクリア用
    juchuKihonId: 0,
    // ページャーが表示されないためデフォルト100行表示を強制的に拡張
    customFooterProps: { 'items-per-page-options': [1000000] },
    page: 1
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    DdDateBox,
    DdCheckbox,
    DdNumericBox,
    DdIconButton,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdJuchuKeiyakuKensakuTextBoxSearchOnly,
    DdDialog
  },
  /**
  * computed
  * 算出プロパティ
  */
  computed: {
    // 上部リストfilter
    filteredRowsUpper () {
      console.log('●HimodukeEdit.filteredrowsUpper', this.upperList)
      return this.rec.upperList
    },
    // 下部リストfilter
    filteredRowsLower () {
      console.log('●HimodukeEdit.filteredrowsLower', this.rec.lowerList, this.keiyakuHojoKbn)
      // チェックOFFの場合、契約補助区分≠2以外を表示
      if (this.keiyakuHojoKbn !== false) {
        return this.rec.lowerList
      } else {
        return this.rec.lowerList.filter(function (elem) {
          return elem.keiyakuHojoKbn !== '2'
        })
      }
    },
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki'
    }),
    // 取引先
    filteredTorihikisakiList () {
      // 出力専用なので絞り込みは行わない
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 照会モード
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    // キャンセルボタン・・・非表示：読取or照会
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    // 保存ボタン・・・・・・表示：読取以外(削除不可、フル)and照会以外(新規、更新)
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    // 保存ボタン・・・・・・上部リストと下部リストが0件の場合、使用不可
    isSaveButtonDisabled () {
      if (this.rec.upperList.length === 0 && this.rec.lowerList.length === 0) {
        return true
      }
      return false
    },
    // 紐づけ、紐づけ解除ボタン・・・・・・表示：読取以外(削除不可、フル)and照会以外(新規、更新)
    isHimodukeButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  /**
   * created
   * DOM作成前に呼び出される
   */
  created () {
    console.log('●HimodukeEdit.created')
    this.id = this.$route.params.id
    // this.initialize()
  },
  /**
   * mounted
   * DOM作成後に呼び出される
   */
  mounted () {
    console.log('●HimodukeEdit.mounted')
    this.initialize()
  },

  /**
   * method
   */
  methods: {
    // 初期値クローン
    getCloneTargetMethod: function () {
      console.log('●HimodukeEdit.getCloneTargetMethod', this.rec)
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      console.log('●HimodukeEdit.beforeRouteLeaveByMenu')
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    /**
     * 受注契約番号のInputEvent
     * @param {*} e 受注契約番号の入力値
     */
    updateField: function (e) {
      console.log('●HimodukeEdit.updateField', e)
      const self = this
      const option = {
        // ★ヘッダ検索
        searchRequestPromise: function () {
          console.log('●HimodukeEdit.searchRequestPromise')
          return new Promise(resolve => {
            self.HttpClient
              .post('/api/v1/VwCD2orcd004001/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        // ★ヘッダ検索
        searchResultMethod: function (data) {
          console.log('●HimodukeEdit.searchResultMethod')
          self.rows = data.payload
          // ★検索条件設定
          self.conditions2.trJuchuKeiyakuId = self.rows[0].id
          self.conditions2.seikyuTorihikisakiCd = self.rows[0].torihikisakiCd
          self.conditions3.trJuchuKeiyakuId = 0
          self.conditions3.seikyuTorihikisakiCd = self.rows[0].torihikisakiCd
          // ★ヘッダ情報設定
          self.rec.trJuchuKeiyakuId = self.rows[0].id
          self.rec.keiyakuNm = self.rows[0].keiyakuNm
          self.rec.seikyuTorihikisakiCd = self.rows[0].torihikisakiCd
          self.rec.keiyakuStartYmd = filter.dateFormatter(self.rows[0].keiyakuStartYmd)
          self.rec.keiyakuEndYmd = filter.dateFormatter(self.rows[0].keiyakuEndYmd)
          self.rec.keiyakuKihonKingaku = self.rows[0].keiyakuKihonKingaku
          self.rec.juchuKeiyakuBiko = self.rows[0].juchuKeiyakuBiko
          self.selected = []
        },
        // ★上部リスト検索
        searchRequestPromise2: function () {
          console.log('●HimodukeEdit.searchRequestPromise2')
          return new Promise(resolve => {
            self.HttpClient
              .post('/api/v1/VwCD2orcd004002/search', self.conditions2)
              .then((data) => {
                resolve(data)
              })
          })
        },
        // ★上部リスト検索
        searchResultMethod2: function (data) {
          console.log('●HimodukeEdit.searchResultMethod2')
          self.rowsUpper = data.payload
          // ★上部リストデータ設定
          self.setUpperData()
        },
        // ★下部リスト検索
        searchRequestPromise3: function () {
          console.log('●HimodukeEdit.searchRequestPromise3')
          return new Promise(resolve => {
            self.HttpClient
              .post('/api/v1/VwCD2orcd004002/search', self.conditions3)
              .then((data) => {
                resolve(data)
              })
          })
        },
        // ★下部リスト検索
        searchResultMethod3: function (data) {
          console.log('●HimodukeEdit.searchResultMethod3')
          self.rowsLower = data.payload
          // ★下部リストデータ設定
          self.setLowerData()

          const cache = {
            rows: self.rows,
            rowsUpper: self.rowsUpper,
            rowsLower: self.rowsLower,
            conditions: self.conditions,
            conditions2: self.conditions2,
            conditions3: self.conditions3,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      if (this.juchuKeiyakuNo !== '') {
        const isValid = this.validateAll(this.$refs)
        console.log('●HimodukeEdit.validate all', isValid)
        this.Effects.loadStart()
        if (isValid) {
          this.conditions.juchuKeiyakuNo = e
          // 検索
          this.search3times(option)
          console.log('●HimodukeEdit.searchResultMethod(検索後)', this.rec, this.rows)
        }
      }
    },
    /**
     * 下部リストのチェックON処理
     * @param {*} e チェックボックスをクリックしたレコード
     */
    itemSelect: function (e) {
      console.log('●HimodukeEdit.itemSelect', e)
      const index = this.rec.lowerList.indexOf(e.item)
      if (e.value === true) {
        // チェックONの場合、契約補助区分に「2：スポット」を設定
        this.rec.lowerList[index].keiyakuHojoKbn = '2'
      } else {
        // チェックOFFの場合、契約補助区分に空白を設定
        this.rec.lowerList[index].keiyakuHojoKbn = ''
      }
    },

    /**
     * 上部データ設定⇒上部リストセット
     */
    setUpperData: function () {
      this.rec.upperList = []
      console.log('●HimodukeEdit.setUpperData(上部リスト設定)', this.rowsUpper.length)
      for (let i = 0; i < this.rowsUpper.length; i++) {
        this.rowsUpper[i].juchuYmd = filter.dateFormatter(this.rowsUpper[i].juchuYmd)
        if (this.rowsUpper[i].sagyoYoteiYmd !== null) {
          this.rowsUpper[i].sagyoYoteiYmd = filter.dateFormatter(this.rowsUpper[i].sagyoYoteiYmd)
        }
        this.setUpperList(this.rowsUpper[i].id)
        console.log('●HimodukeEdit.setUpperData(上部リスト設定_2)：', this.rec.upperList)
      }
    },
    /**
     * 下部データ設定⇒下部リストセット
     */
    setLowerData: function () {
      this.rec.lowerList = []
      console.log('●HimodukeEdit.setLowerData(下部リスト設定)：', this.rowsLower.length)
      for (let i = 0; i < this.rowsLower.length; i++) {
        this.setLowerList(this.rowsLower[i].id)
        this.rowsLower[i].juchuYmd = filter.dateFormatter(this.rowsLower[i].juchuYmd)
        if (this.rowsLower[i].sagyoYoteiYmd !== null) {
          this.rowsLower[i].sagyoYoteiYmd = filter.dateFormatter(this.rowsLower[i].sagyoYoteiYmd)
        }
        console.log('●HimodukeEdit.setLowerData(下部リスト設定_2)：', this.rec.lowerList)
      }
    },

    /**
     * 上部リストセット（契約連携済み受注一覧）
     * @param {*} listId 受発注作業リレーションID
     */
    setUpperList: function (listId) {
      console.log('●HimodukeEdit.setUpperList', listId)
      if (listId !== null && listId.trim !== '') {
        console.log('●HimodukeEdit.setUpperList_2', this.rowsUpper)
        const listArr = this.rowsUpper.filter(item => item.id === listId)
        // 最終行に追加
        this.rec.upperList[this.rec.upperList.length] = listArr[0]
      }
    },

    /**
     * 下部リストセット（契約未連携受注一覧）
     * @param {*} listId 受発注作業リレーションID
     */
    setLowerList: function (listId) {
      console.log('●HimodukeEdit.setLowerList', listId)
      if (listId !== null && listId.trim !== '') {
        console.log('●HimodukeEdit.setLowerList_2', this.rowsLower)
        const listArr = this.rowsLower.filter(item => item.id === listId)
        // 最終行に追加
        this.rec.lowerList[this.rec.lowerList.length] = listArr[0]
      }
    },

    initialize () {
      console.log('●HimodukeEdit.initialize')
      const self = this
      const option = {
        loadMasters: ['msttorihikisaki'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.rec = {
              juchuKeiyakuNo: '',
              keiyakuNm: '',
              seikyuTorihikisakiCd: '',
              keiyakuStartYmd: '',
              keiyakuEndYmd: '',
              keiyakuKihonKingaku: 0,
              juchuKeiyakuBiko: '',
              upperList: [], // 上部リストデータ格納用
              lowerList: [] // 下部リストデータ格納用
            }
            self.conditions = {
              juchuKeiyakuNo: ''
            }
            self.conditions2 = {
              trJuchuKeiyakuId: 0,
              seikyuTorihikisakiCd: ''
            }
            self.conditions3 = {
              trJuchuKeiyakuId: 0,
              seikyuTorihikisakiCd: ''
            }
            self.keiyakuHojoKbn = false
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            console.log('●HimodukeEdit.savedInputRestorePromise')
            resolve()
          })
        },
        existsIdMethod: function () {
          console.log('●HimodukeEdit.existsIdMethod', self.id)
          // return self.id !== 0
          return true
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('●HimodukeEdit.settingButtonStatePromise(権限、ID)', kengen.kengenKbn, this.id)
            if (kengen.kengenKbn === '10') {
              this.modeKengen = 0 // 読取モード
            } else if (kengen.kengenKbn === '20') {
              this.modeKengen = 1 // 削除不可モード
            } else {
              this.modeKengen = 2 // フルアクセス
            }
            // TODO 2021/02/18：idはUndefinedでくるため、modeOfEditはユーザ権限でのみ判断することになる気がする。
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            resolve()
            console.log('●HimodukeEdit.settingButtonStatePromise(modeKengen、modeOfEdit)', this.modeKengen, this.modeOfEdit)
          })
        }
      }
      this.initializeForViewer(option)
    },

    /**
     * 検索(3件用)
     * @param {*} option searchRequestPromise(3件分)、searchResultMethod(3件分)、getSavedInputMethod
     */
    search3times: function (option) {
      console.log('●HimodukeEdit.search3times:option', option)
      const self = this
      const opt = {
        searchRequestPromise: option.searchRequestPromise || self._dummyPromiseMethod,
        searchResultMethod: option.searchResultMethod || self._dummyObjectsMethod,
        searchRequestPromise2: option.searchRequestPromise2 || self._dummyPromiseMethod,
        searchResultMethod2: option.searchResultMethod2 || self._dummyObjectsMethod,
        searchRequestPromise3: option.searchRequestPromise3 || self._dummyPromiseMethod,
        searchResultMethod3: option.searchResultMethod3 || self._dummyObjectsMethod,
        getSavedInputMethod: option.getSavedInputMethod || self._dummyObjectsMethod
      }

      const isValid = self._validateSearchProcess()
      if (!isValid) { return }

      self.Effects.loadStart()

      // const param = {
      //   kinoId: self.currentKinoId,
      //   obj: opt.getSavedInputMethod()
      // }

      // self.$store.dispatch('DDMasters/registerSavedInput', param).then(() => {
      opt.searchRequestPromise().then(data => {
        console.log('searchRequestPromise', data)

        self._setMessages(data).then(() => {
          if (data.isValid) {
            opt.searchResultMethod(data)

            opt.searchRequestPromise2().then(data => {
              console.log('searchRequestPromise2', data)
              self._setMessages(data).then(() => {
                if (data.isValid) {
                  opt.searchResultMethod2(data)

                  opt.searchRequestPromise3().then(data => {
                    console.log('searchRequestPromise3', data)
                    self._setMessages(data).then(() => {
                      if (data.isValid) {
                        opt.searchResultMethod3(data)
                      }
                    })
                    self.Effects.loadComplete()
                  })
                } else {
                  self.Effects.loadComplete()
                }
              })
            })
          } else {
            self.Effects.loadComplete()
          }
        })
      })
    },

    /**
     * 上部リストから削除
     * @param {*} item 対象レコード
     */
    deleteUpperList: function (item) {
      console.log('●HimodukeEdit.deleteUpperList', item)
      const index = this.rec.upperList.indexOf(item)
      this.rec.upperList.splice(index, 1)
    },
    /**
     * 下部リストから削除
     * @param {*} item 対象レコード
     */
    deleteLowerList: function (item) {
      console.log('●HimodukeEdit.deleteLowerList', item)
      const index = this.rec.lowerList.indexOf(item)
      this.rec.lowerList.splice(index, 1)
    },
    /**
     * 紐づけ解除（下部リストへ移動）
     * @param {*} item 対象レコード
     */
    downList: function (item) {
      console.log('●HimodukeEdit.downList', this.rec, item)
      this.rec.lowerList.push(item)
      this.deleteUpperList(item)
    },
    /**
     * 紐づけ（上部リストへ移動）
     * @param {*} item 対象レコード
     */
    upList: function (item) {
      console.log('●HimodukeEdit.upList', this.rec, item)
      this.rec.upperList.push(item)
      this.deleteLowerList(item)
    },

    /**
     * キャンセルボタンクリック
     * @param {*} e
     */
    onCancelButtonClick: function (e) {
      console.log('●HimodukeEdit.onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.keiyakuHojoKbn = false
            self.selected = []

            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    /**
     * 保存ボタンクリック
     * @param {*} e
     */
    onSaveButtonClick: function (e) {
      console.log('●HimodukeEdit.onSaveButtonClick', e)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          console.log('●HimodukeEdit.registerResponsePromise', data)
          return new Promise(resolve => {
            self.id = data.payload.id
            self.keiyakuHojoKbn = false
            self.selected = []

            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            // this.transition(1, { id: id }, this.initialize)
            this.transition(0, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      console.log('●HimodukeEdit.registerPromise')
      var updateList = {}
      updateList.trJuhacchusagyoRelationUpperList = this.rec.upperList
      updateList.trJuhacchusagyoRelationLowerList = this.rec.lowerList
      updateList.juhacchuKbn = '1'
      updateList.registerKeiyakuId = this.rec.trJuchuKeiyakuId
      console.log('●HimodukeEdit.registerPromise(更新用配列)', updateList)
      const f = this.HttpClient.post('/api/v1/TrJuhacchusagyoRelation/UpdateMulti?id=1', updateList)
      return f
    },
    onJuchuEditDialogOpen: function (item) {
      console.log('●HimodukeEdit.onJuchuEditDialogOpen', item)
      this.juchuKihonId = item.trJuchuKihonId
      this.juchuEditDialog = true
    },
    onJuchuEditDialogClosed: function (e) {
      console.log('●HimodukeEdit.onJuchuEditDialogClosed', e)
      this.juchuEditDialog = false
      if (e === undefined) { return }
      this.rec = e
    },
    registerValidate: function () {
      console.log('●HimodukeEdit.registerValidate')
      return true
    },
    searchValidate: function () {
      console.log('●HimodukeEdit.searchValidate')
      return true
    }

  }
}
